export enum AuthFailReason {
  NoOrganizations = "no_organizations",
  Other = "other",
  UnknownUserOrWrongPassword = "unknown_user_or_wrong_password",
}
